module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Italic.woff?v=02f3ec726d5005db77e613dbf205f467";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Italic.woff
// module id = 651
// module chunks = 0